import React, { useState } from 'react';
import '../styles/ChatAssistant.css';

const ChatAssistant = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleChat = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="chat-assistant-container">
            {isOpen && (
                <div className="chat-window">
                    <div className="chat-header">
                        <h3>i2r IoT PLC & Sensor Assistant</h3>
                        <button onClick={toggleChat} className="close-btn">&times;</button>
                    </div>
                    <div className="chat-body">
                        <div className="chat-message bot">
                            <p>Hello! How can I help you with i2r products today?</p>
                        </div>
                        {/* Placeholder for more messages */}
                    </div>
                    <div className="chat-input">
                        <input type="text" placeholder="Type a message..." />
                        <button className="send-btn"><i className="fas fa-paper-plane"></i></button>
                    </div>
                </div>
            )}
            <button className="chat-fab" onClick={toggleChat}>

                {isOpen ? (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                ) : (
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.4876 3.36093 14.891 4.00566 16.1267L3 21L7.87333 19.9943C9.10904 20.6391 10.5124 21 12 21Z" fill="white" />
                        <circle cx="8" cy="12" r="1.5" fill="#007FFF" />
                        <circle cx="12" cy="12" r="1.5" fill="#007FFF" />
                        <circle cx="16" cy="12" r="1.5" fill="#007FFF" />
                    </svg>
                )}
            </button>
        </div>
    );
};

export default ChatAssistant;
